import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import InstrumentRowContainer from '@alphapoint/apex-web/lib/components/InstrumentRow';
import PriceChartContainer from '@alphapoint/apex-web/lib/components/PriceChart/PriceChartContainer';
import DepthChartContainer from '@alphapoint/apex-web/lib/components/DepthChart/DepthChartContainer';
import OrderBookContainer from '@alphapoint/apex-web/lib/components/OrderBookComponents/OrderBookContainer';
import RecentTradesContainer from '@alphapoint/apex-web/lib/components/RecentTrades/RecentTradesContainer';
import { initSelectedInstrument } from '@alphapoint/apex-web/lib/redux/actions/instrumentActions';
import { getBEMClasses } from '@alphapoint/apex-web/lib/helpers/cssClassesHelper';

import config from '../../config';
import PageHeaderLayout from '../../layouts/PageHeaderLayout/PageHeaderLayout';

import './SimpleExchangePage.css';
import {
  instrumentSelectorEnabledInstruments,
  selectedInstrumentIdSelector,
} from '@alphapoint/apex-web/lib/redux/selectors/instrumentPositionSelectors';
import { useInstrumentUrlSync } from '@alphapoint/apex-web/lib/components/InstrumentSelector/hooks/useInstrumentUrlSync';
import { showSnack } from '@alphapoint/apex-web/lib/redux/actions/snackbarActions';

const exchangePageClasses = getBEMClasses('simple-exchange-page');

const SimpleExchange = ({ selectedInstrumentId, instruments, initSelectedInstrument, showSnack }) => {
  const { t } = useTranslation();
  const history = useHistory();

  useEffect(() => {
    const tradingServer = window.localStorage.getItem('tradingServer');
    const gatewayConfig = config.global.gateway;
    const requiresServerSelection = Array.isArray(gatewayConfig);

    if (requiresServerSelection && !tradingServer) {
      const message = t('Must select a trading server');
      showSnack({
        id: 'MissingTradingServer',
        text: message,
        type: 'warning',
      });
      history.replace('/login');
    }
  }, [history, showSnack, t]);

  useInstrumentUrlSync({
    instruments,
    selectedInstrumentId,
    initSelectedInstrument,
    routePrefix: config.SimpleExchange.route,
  });

  return (
    <div className={exchangePageClasses('outer-wrapper')}>
      <PageHeaderLayout />
      <div className={exchangePageClasses('container')}>
        <div className={exchangePageClasses('row')}>
          <InstrumentRowContainer />
        </div>
        <div className={exchangePageClasses('body')}>
          <div className={exchangePageClasses('chart-container')}>
            <div className={exchangePageClasses('chart-header')}>{t('Price Chart')}</div>
            <PriceChartContainer />
            <DepthChartContainer />
          </div>
          <div className={exchangePageClasses('column-container')}>
            <div className={exchangePageClasses('title')}>{t('Order Book')}</div>
            <OrderBookContainer />
          </div>

          <div className={exchangePageClasses('column-container')}>
            <div className={exchangePageClasses('title')}>{t('Recent Trades')}</div>
            <RecentTradesContainer />
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  const selectedInstrumentId = selectedInstrumentIdSelector(state);
  const instruments = instrumentSelectorEnabledInstruments(state);

  return {
    selectedInstrumentId,
    instruments,
  };
};

const mapDispatchToProps = {
  initSelectedInstrument,
  showSnack,
};

export const SimpleExchangePage = connect(mapStateToProps, mapDispatchToProps)(SimpleExchange);
